import React, { useCallback, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import "../table/FilteringTable/filtering.css";
import PageTitle from "../../layouts/PageTitle";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { Dropdown } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { Form, Row, Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { setCourses } from "../../../store/actions/CourseAction";
import { useDispatch } from "react-redux";
import { fetchCourses } from "../../../store/actions/CourseAction";
import { API_URL } from "../../../config";
import { logoutonexpire } from "../../../store/actions/AuthActions";
import { useRef } from "react";

export const StudentsList = () => {
  const history = useHistory();
  const isInitialLoad = useRef(true);
  const courses = useSelector((state) => state.courses.courses); // Access the courses data
  // console.log(courses);
  const collegeId = useSelector((state) => state.college_id.college_id);
  const [studentList, setStudentData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [studentsPerPage] = useState(10); // Number of students to display per page
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false); // Loading state
  const [passoutYear, setPassoutYear] = useState("Passout Year");
  const [course, setCourse] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const payload = { college_id: collegeId };

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [courseId, setCourseId] = useState(null);
  const [masterCourseId, setMasterCourseId] = useState(null);
  const [specId, setSpecId] = useState(null);
  const [passoutYearForm, setPassoutYearForm] = useState("");
  const [specializationData, setSpecializationData] = useState([]);
  const [interestedPlacement, setInterestedPlacement] = useState(1);
  const [interestedHigherStudy, setInterestedHigherStudy] = useState(1);
  const [studentId, setStudentId] = useState(null);
  const currentYear = new Date().getFullYear();
  const [courseList, setCourseList] = useState("Choose Course");
  const [courseIdList, setCourseIdList] = useState(null);
  const [specialization, setSpecialization] = useState("Choose Specialization");
  const [specializationId, setSpecializationId] = useState(null);
  const [coursefilterId, setCourseIdfilter] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isExporting, setIsExporting] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    const storedCourses = localStorage.getItem("courses");
    if (storedCourses) {
      dispatch(setCourses(JSON.parse(storedCourses)));
    }
  }, [dispatch]);

  useEffect(() => {
    // console.log("courseId", courseId);
    // console.log("coursefilterId", coursefilterId);
    if (courseId == null && coursefilterId == null) {
      setSpecializationData([]);
    }
    if (courseId != null) {
      const payload = { college_id: collegeId, course_id: courseId };
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const authToken = userDetails?.data?.auth_token;

      axios
        .get(
          `${API_URL}/api/freshment_portal_apis/GenericAPI/get_course_spealization_list`,
          {
            params: payload,
            headers: {
              Authorization: authToken,
            },
          },
        )
        .then((response) => {
          setSpecializationData(response.data.data);
          // console.log(response.data.data);
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            dispatch(logoutonexpire());
          }
          console.log("err======", err);
        });
    } else if (coursefilterId != null) {
      const payload = { college_id: collegeId, course_id: coursefilterId };
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const authToken = userDetails?.data?.auth_token;

      axios
        .get(
          `${API_URL}/api/freshment_portal_apis/GenericAPI/get_course_spealization_list`,
          {
            params: payload,
            headers: {
              Authorization: authToken,
            },
          },
          // {
          //   headers: {
          //     "Access-Control-Allow-Origin": "*",
          //     "Access-Control-Allow-Headers":
          //       "Origin, X-Requested-With, Content-Type, Accept, Authorization",
          //     "Content-Type":
          //       "application/x-www-form-urlencoded; charset=UTF-8;application/json",
          //   },
          // }
        )
        .then((response) => {
          setSpecializationData(response.data.data);
          // console.log(response.data.data);
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            dispatch(logoutonexpire());
          }
          console.log("err======", err);
        });
    }
  }, [courseId, coursefilterId]);

  const handleSubmit = () => {
    // e.preventDefault();
    // Prepare payload for the API
    const payload = {
      student_id: studentId,
      full_name: fullName,
      email: email,
      phone_number: phoneNumber,
      course_id: masterCourseId,
      passout_year: passoutYearForm,
      college_connect_id: collegeId,
      specialization_id: specId,
      interested_in_placement: interestedPlacement,
      interested_in_higher_education: interestedHigherStudy,
    };
    // console.log(payload);

    const params = new URLSearchParams();
    if (isEditing) {
      params.append("student_id", payload.student_id);
    }
    params.append("college_connect_id", payload.college_connect_id);
    params.append("full_name", payload.full_name);
    params.append("email", payload.email);
    params.append("phone_number", payload.phone_number);
    params.append("course_id", payload.course_id);
    params.append("passout_year", payload.passout_year);
    if (
      payload.specialization_id !== null &&
      payload.specialization_id !== "" &&
      payload.specialization_id !== "Select Specialization"
    ) {
      params.append("specialization_id", payload.specialization_id);
    }
    params.append("interested_in_placement", payload.interested_in_placement);
    params.append(
      "interested_in_higher_education",
      payload.interested_in_higher_education,
    );

    // console.log(params);
    if (isEditing) {
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const authToken = userDetails?.data?.auth_token;

      axios
        .post(
          `${API_URL}/api/freshment_portal_apis/students/update_student_details`,
          params,
          {
            headers: {
              "Content-Type":
                "application/x-www-form-urlencoded; charset=UTF-8",
              Authorization: authToken,
            },
          },
        )
        .then((response) => {
          // console.log(response);
          if (response.data.success) {
            toast.success("Student Details Updated successfully!");
            setIsEditing(false);
            setModalShow(false);
            // Optionally refresh the student list here
            fetchStudentList();
            setFullName("");
            setEmail("");
            setPhoneNumber("");
            setCourseId(null);
            setMasterCourseId(null);
            setSpecId(null);
            setPassoutYearForm("");
            setInterestedPlacement(1);
            setInterestedHigherStudy(1);
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            dispatch(logoutonexpire());
          }
          toast.error("Failed to add student.");
        });
    } else {
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const authToken = userDetails?.data?.auth_token;

      axios
        .post(
          `${API_URL}/api/freshment_portal_apis/Students/add_student_details`,
          params,
          {
            headers: {
              Authorization: authToken,
              "Content-Type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          },
        )
        .then((response) => {
          // console.log(response);
          if (response.data.success) {
            toast.success("Student added successfully!");
            setModalShow(false);
            // Optionally refresh the student list here
            fetchStudentList();
            setFullName("");
            setEmail("");
            setPhoneNumber("");
            setCourseId(null);
            setMasterCourseId(null);
            setSpecId(null);
            setPassoutYearForm("");
            setInterestedPlacement(1);
            setInterestedHigherStudy(1);
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            dispatch(logoutonexpire());
          }
          toast.error("Failed to add student.");
        });
    }
  };

  const handleEdit = (name, id) => {
    const student = studentList.find(
      (student) => student.onboarding_student_id == id,
    );
    // console.log(student);
    setStudentId(student.onboarding_student_id);
    setIsEditing(true);
    setFullName(student.full_name);
    setEmail(student.email);
    setPhoneNumber(student.phone_number);
    // setCourseId(student.course_id);
    const coursemaster = courses.find(
      (courses) => courses.course_master_id == student.course_id,
    );
    setMasterCourseId(coursemaster.course_master_id);
    setSpecId(student.specialization_id);
    setPassoutYearForm(student.passout_year);
    setModalShow(true);
  };

  useEffect(() => {
    if (masterCourseId !== null) {
      const coursemaster = courses?.find(
        (courses) => courses?.course_master_id == masterCourseId,
      );
      setCourseId(coursemaster.college_course_id);
    }
  }, [masterCourseId, course]);

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const authToken = userDetails?.data?.auth_token;

    const payload = { college_id: collegeId };
    axios
      .get(
        `${API_URL}/api/freshment_portal_apis/GenericAPI/get_courses_list`,
        {
          params: payload,
          headers: {
            Authorization: authToken,
          },
        },
        // {
        //   headers: {
        //     "Access-Control-Allow-Origin": "*",
        //     "Access-Control-Allow-Headers":
        //       "Origin, X-Requested-With, Content-Type, Accept, Authorization",
        //     "Content-Type":
        //       "application/x-www-form-urlencoded; charset=UTF-8;application/json",
        //   },
        // }
      )
      .then((response) => {
        setCourse(response.data.data);
        // console.log(response.data.data);
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          dispatch(logoutonexpire());
        }
        console.log("err======", err);
      });
  }, []);

  const fetchStudentList = async () => {
    setLoading(true); // Set loading to true before fetching data
    const params = {
      ...payload,
      offset: currentPage * studentsPerPage,
      limit: studentsPerPage,
      // search: search,
    };
    if (passoutYear !== "Passout Year") {
      params.filter_by_passout_year = passoutYear;
    }

    if (courseIdList !== null && courseList !== "Choose Course") {
      params.filter_by_course = parseInt(courseIdList);
    }

    if (specialization !== null && specialization !== "Choose Specialization") {
      params.filter_by_specialization = parseInt(specializationId);
    }
    if (search !== "") {
      params.search = search;
    }
    // console.log(params);
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const authToken = userDetails?.data?.auth_token;

    try {
      const response = await axios.get(
        `${API_URL}/api/freshment_portal_apis/students/get_student_list`,
        {
          params,
          headers: {
            Authorization: authToken,
          },
        },
      );
      const { data, totalRecords } = response.data;
      console.log(response);
      setStudentData(data);
      setTotalRecords(totalRecords);
      // setCurrentPage(0); // Reset to the first page on new search
    } catch (err) {
      if (err?.response?.status === 401) {
        dispatch(logoutonexpire());
      }
      console.error("Error fetching student list:", err);
      // Optionally show an alert or notification for the error
    } finally {
      setLoading(false); // Set loading to false after fetching data
    }
  };

  // useEffect(() => {
  //   fetchStudentList(); // Fetch all students on initial load
  // }, []);

  const handleSearch = () => {
    fetchStudentList(); // Fetch based on search input when button clicked
  };

  // Logic for displaying current students

  const totalPages = Math.ceil(totalRecords / studentsPerPage);

  const indexOfLastStudent = (currentPage + 1) * studentsPerPage;
  const indexOfFirstStudent = indexOfLastStudent - studentsPerPage;

  // Prevent accessing invalid indexes
  // const currentStudents = studentList?.slice(
  //   indexOfFirstStudent,
  //   indexOfLastStudent > totalRecords ? totalRecords : indexOfLastStudent
  // );

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 0 && pageNumber < totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleDelete = (props) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",

      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-primary btn-sm",
        cancelButton: "btn btn-danger btn-sm ms-2",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const params = new URLSearchParams();
        params.append("student_id", props.id);
        params.append("college_connect_id", props.collegeid);
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        const authToken = userDetails?.data?.auth_token;

        axios
          .post(
            `${API_URL}/api/freshment_portal_apis/Students/delete_student_details`,
            params, // Pass the encoded params
            {
              headers: {
                Authorization: authToken,
                "Content-Type":
                  "application/x-www-form-urlencoded; charset=UTF-8",
              },
            },
          )
          .then((res) => {
            if (res.data.success === true) {
              toast.success(res.data.message);
              fetchStudentList();
              // window.location.reload();
            } else {
              toast.error(res.data.message);
            }
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              dispatch(logoutonexpire());
            }
            console.error(err);
            toast.error("An error occurred while deleting the student.");
          });
      }
    });
  };

  // useEffect(() => {
  //   if (isInitialLoad.current) {
  //     fetchStudentList(); // Fetch jobs on initial render
  //     isInitialLoad.current = false; // Mark as not initial load
  //   }
  // }, []);

  const isResettingRef = useRef(false);

  const resetFilter = useCallback(() => {
    isResettingRef.current = true;
    setCurrentPage(0);
    setSearch("");
    setCourseIdList(null);
    setCourseIdfilter(null);
    setCourseList("Choose Course");
    setMasterCourseId(null);
    setSpecializationId(null);
    setSpecialization("Choose Specialization");
    setPassoutYear("Passout Year");

    setTimeout(() => {
      fetchStudentList();
      isResettingRef.current = false;
    }, 10);
  }, []);

  useEffect(() => {
    if (!isResettingRef.current) {
      fetchStudentList();
    }
  }, [specialization, passoutYear, courseList, currentPage]);

  // useEffect(() => {
  //   console.log(
  //     "specialization, passoutYear, courseList, currentPage",
  //     specialization,
  //     passoutYear,
  //     courseList,
  //     currentPage
  //   );
  // }, [specialization, passoutYear, courseList, currentPage]);

  const renderPageNumbers = () => {
    const pages = [];
    const startPage = Math.max(
      0,
      currentPage - Math.floor(studentsPerPage / 2),
    );
    const endPage = Math.min(totalPages - 1, startPage + studentsPerPage - 1);

    if (startPage > 0)
      pages.push(
        <span key="start-ellipsis" style={{ fontSize: 24 }}>
          ...
        </span>,
      );

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li className="page-item">
          <Link
            key={i}
            to="#"
            className={`page-link ${
              i === currentPage ? "bg-primary text-white" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i + 1}
          </Link>
        </li>,
      );
    }

    if (endPage < totalPages - 1)
      pages.push(
        <span key="end-ellipsis" style={{ fontSize: 24 }}>
          ...
        </span>,
      );

    return pages;
  };

  const handleExport = async () => {
    try {
      setIsExporting(true);
      const params = {
        ...payload,
        export_required: 1,
        offset: currentPage * studentsPerPage,
        limit: studentsPerPage,
      };
      if (passoutYear !== "Passout Year") {
        params.filter_by_passout_year = passoutYear;
      }

      if (courseIdList !== null && courseList !== "Choose Course") {
        params.filter_by_course = parseInt(courseIdList);
      }

      if (
        specialization !== null &&
        specialization !== "Choose Specialization"
      ) {
        params.filter_by_specialization = parseInt(specializationId);
      }
      if (search !== "") {
        params.search = search;
      }
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const authToken = userDetails?.data?.auth_token;

      try {
        const response = await axios.get(
          `${API_URL}/api/freshment_portal_apis/students/get_student_list`,
          {
            params,
            headers: {
              Authorization: authToken,
            },
          },
        );
        if (response.data.success) {
          const a = document.createElement("a");
          a.href = response.data.csv_file_path;
          a.download = "students.csv";
          a.click();
        } else {
          toast.error("Failed to export students.");
        }
      } catch (error) {
        console.error("Error exporting students:", error);
        toast.error("Failed to export students.");
      } finally {
        setIsExporting(false);
      }
    } catch (error) {
      console.error("Error exporting data:", error);
      toast.error("Failed to export students.");
      setIsExporting(false);
    }
  };

  return (
    <>
      <PageTitle activeMenu="StudentsList" motherMenu="Students" />

      <div className="d-flex align-items-center flex-wrap search-job bg-white px-0 mb-4">
        <div className="col-xl-2 col-xxl-2 col-lg-4 col-sm-4 col-12 search-dropdown d-flex align-items-center">
          <Dropdown className="form-control border-0 style-1 h-auto">
            <Dropdown.Toggle
              as="div"
              className="fs-16 font-w500 text-primary justify-content-between d-flex align-items-center i-false"
            >
              {courseList}
              <i className="fas fa-angle-down text-primary scale5 ms-3"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu dropdown-menu-end mt-1">
              <Dropdown.Item
                className="text-primary"
                onClick={() => {
                  setCourseIdList(null);
                  setCourseIdfilter(null);
                  setMasterCourseId(null);
                  setCourseList("Choose Course");
                  setSpecializationId(null);
                  setSpecialization("Choose Specialization");
                  setCurrentPage(0);
                }}
              >
                Choose Course
              </Dropdown.Item>
              {courses?.map((course) => (
                <Dropdown.Item
                  className="text-primary"
                  onClick={() => {
                    setCourseIdList(course.filter_id);
                    setCourseIdfilter(course.college_course_id);
                    setCourseList(course.name);
                    setSpecializationId(null);
                    setSpecialization("Choose Specialization");
                    setCurrentPage(0);
                  }}
                >
                  {course.name}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-xl-3 col-xxl-3 col-lg-4 col-sm-4 col-12 search-dropdown d-flex align-items-center">
          <Dropdown className="form-control border-0 style-1 h-auto">
            <Dropdown.Toggle
              as="div"
              className="fs-16 font-w500 text-primary justify-content-between d-flex align-items-center i-false"
            >
              {specialization}
              <i className="fas fa-angle-down text-primary scale5 ms-3"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu dropdown-menu-end mt-1">
              <Dropdown.Item
                className="text-primary"
                onClick={() => {
                  setSpecializationId(null);
                  setCurrentPage(0);
                  setSpecialization("Choose Specialization");
                }}
              >
                Choose Specialization
              </Dropdown.Item>

              {specializationData && specializationData?.length > 0 ? (
                specializationData?.map((specialization) => (
                  <Dropdown.Item
                    className="text-primary"
                    onClick={() => {
                      setCurrentPage(0);

                      setSpecializationId(
                        specialization.specilization_master_id,
                      );
                      setSpecialization(specialization.name);
                    }}
                  >
                    {specialization.name}
                  </Dropdown.Item>
                ))
              ) : (
                <Dropdown.Item
                  className="text-primary"
                  onClick={() => {
                    setSpecializationId(0);
                    setSpecialization("All");
                    setCurrentPage(0);
                  }}
                >
                  All
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-xl-2 col-xxl-2 col-lg-4 col-sm-4 col-12 search-dropdown d-flex align-items-center">
          <Dropdown className="form-control border-0  style-1 h-auto">
            <Dropdown.Toggle
              as="div"
              className="fs-16 font-w500 text-primary justify-content-between d-flex align-items-center i-false"
            >
              {passoutYear}
              <i className="fas fa-angle-down text-primary scale5 ms-3"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu dropdown-menu-end mt-1">
              <Dropdown.Item
                className=" text-primary"
                onClick={() => {
                  setCurrentPage(0);
                  setPassoutYear("Passout Year");
                }}
              >
                Passout Year
              </Dropdown.Item>
              <Dropdown.Item
                className=" text-primary"
                onClick={() => {
                  setCurrentPage(0);
                  setPassoutYear(currentYear - 1);
                }}
              >
                {currentYear - 1}
              </Dropdown.Item>
              <Dropdown.Item
                className=" text-primary"
                onClick={() => {
                  setCurrentPage(0);
                  setPassoutYear(currentYear);
                }}
              >
                {currentYear}
              </Dropdown.Item>
              <Dropdown.Item
                className=" text-primary"
                onClick={() => {
                  setCurrentPage(0);
                  setPassoutYear(currentYear + 1);
                }}
              >
                {currentYear + 1}
              </Dropdown.Item>
              <Dropdown.Item
                className=" text-primary"
                onClick={() => {
                  setCurrentPage(0);
                  setPassoutYear(currentYear + 2);
                }}
              >
                {currentYear + 2}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-xl-4 col-xxl-4 col-lg-12 col-12 d-md-flex job-title-search pe-0">
          <div className="input-group search-area">
            <input
              type="text"
              className="form-control h-auto"
              placeholder="Search student name/email..."
              value={search}
              onChange={(e) => {
                setCurrentPage(0);
                setSearch(e.target.value);
              }}
            />
            <span className="input-group-text">
              <Button onClick={handleSearch} className="btn btn-primary btn-sm">
                Search{" "}
                <i
                  className="flaticon-381-search-2 ms-1"
                  style={{ fontSize: "14px", verticalAlign: "middle" }}
                ></i>
              </Button>
            </span>
          </div>
        </div>
        <div className="col-xl-1 col-xxl-1 col-lg-1 col-12 d-flex align-items-center justify-content-lg-end justify-content-center">
          <Button variant="danger btn-sm" onClick={resetFilter}>
            Reset
          </Button>
        </div>
      </div>

      {loading ? (
        <div className="text-center my-4">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : studentList && studentList.length > 0 ? (
        <div
          className="table-responsive dataTables_wrapper"
          id="application-data"
        >
          <table className="table display mb-4 dataTablesCard job-table table-responsive-xl card-table dataTable no-footer">
            <thead>
              <tr role="row">
                <th colSpan={5}>
                  <p className="fs-22 m-0">Students List</p>
                </th>
                <th className="text-end">
                  <Button
                    variant="primary"
                    className="btn-sm"
                    onClick={handleExport}
                    disabled={isExporting}
                  >
                    {isExporting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Exporting...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-file-export me-2"></i>
                        Export Students
                      </>
                    )}
                  </Button>
                </th>
                {/* <th
                  colSpan={1}
                  className="d-flex align-items-end justify-content-end"
                >
                  <Button
                    variant=""
                    className="btn btn-primary btn-sm"
                    onClick={() => {
                      setIsEditing(false);
                      setFullName("");
                      setEmail("");
                      setPhoneNumber("");
                      setCourseId(null);
                      setMasterCourseId(null);
                      setSpecId(null);
                      setPassoutYearForm("");
                      setInterestedPlacement(1);
                      setInterestedHigherStudy(1);
                      setModalShow(true);
                    }}
                  >
                    Add Student
                  </Button>
                </th> */}
              </tr>
              <tr role="row">
                <th className="sorting_asc">Full Name</th>
                <th className="sorting_asc">Email</th>
                <th className="sorting_asc">Phone Number</th>
                <th className="sorting_asc">Course</th>
                <th className="sorting_asc">Passout Year</th>
                <th className="sorting_asc text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {studentList?.map((student) => (
                <tr role="row" key={student.id} className="odd">
                  <td>{student.full_name}</td>
                  <td>{student.email}</td>
                  <td>{student.phone_number || "N/A"}</td>
                  <td>
                    {student.course_name}
                    {student.specialization_name
                      ? ` (${student.specialization_name})`
                      : ""}
                  </td>
                  <td>{student.passout_year}</td>
                  <td
                    className="action-btn d-flex align-items-center justify-content-center wspace-no"
                    style={{ gap: 5 }}
                  >
                     <Button
                      onClick={() =>
                        // history.push(`/edit-student/${student.onboarding_student_id}`)
                         handleEdit(
                          student.full_name,
                          student.onboarding_student_id,
                        )
                      }
                      size="sm"
                      variant="primary"
                      className="btn-sm"
                    >
                      Edit
                    </Button> 
                    <Button
                      as={Link}
                      to={`/user-profile/${student.onboarding_student_id}`}
                      size="sm"
                      variant="secondary"
                      className="btn-sm"
                    >
                      View
                    </Button>
                    <Button
                      onClick={() => {
                        handleDelete({
                          id: student.onboarding_student_id,
                          collegeid: student.college_connect_id,
                        });
                      }}
                      size="sm"
                      variant="danger"
                      className="btn-sm"
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="d-sm-flex text-center justify-content-between align-items-center">
            <div className="dataTables_info" id="example5_info">
              Showing {indexOfFirstStudent + 1} to{" "}
              {Math.min(indexOfLastStudent, totalRecords)} of {totalRecords}{" "}
              entries
            </div>
            <ul className="pagination pagination-circle">
              <li
                className={`page-item page-indicator ${currentPage === 0 ? "disabled" : ""}`}
              >
                <Link
                  to="#"
                  className={`page-link ${currentPage === 0 ? "disabled" : ""}`}
                  onClick={() =>
                    currentPage > 0 && handlePageChange(currentPage - 1)
                  }
                >
                  Prev
                </Link>
              </li>
             
                {renderPageNumbers()}
                {/* <span> {[...Array(totalPages)].map((_, i) => (
                  <Link
                    key={i}
                    to="#"
                    className={`paginate_button ${
                      i === currentPage ? "bg-white" : ""
                    }`}
                    onClick={() => handlePageChange(i)}
                  >
                    {i + 1}
                  </Link>
                ))}  </span>*/}
             
              <li
                className={`page-item page-indicator ${
                  currentPage + 1 >= totalPages ? "disabled" : ""
                }`}
              >
                <Link
                  to="#"
                  className={`page-link ${
                    currentPage + 1 >= totalPages ? "disabled" : ""
                  }`}
                  onClick={() =>
                    currentPage + 1 < totalPages &&
                    handlePageChange(currentPage + 1)
                  }
                >
                  Next
                </Link>
              </li>
            </ul>
          </div>
        </div>
      ) : (
        <div>No Students Found</div>
      )}
      <Modal show={modalShow} onHide={() => setModalShow(false)} centered>
        <Modal.Header>
          <Modal.Title>
            {isEditing ? "Edit Student Details" : "Add New Student"}
          </Modal.Title>

          <Button
            onClick={() => setModalShow(false)}
            variant=""
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formFullName">
              <Form.Label>Full Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter full name"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="formEmail" className="mt-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                value={email}
                disabled={isEditing && email != "" ? true : false}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="formPhoneNumber" className="mt-3">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter phone number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mt-3">
              <Form.Label>Select Course</Form.Label>
              <Form.Control
                as="select"
                value={masterCourseId}
                onChange={(e) => {
                  if (e.target.value == "Select Course") {
                    setMasterCourseId(null);
                    setSpecId("Select Specialization");
                    setSpecializationData([]);
                  } else {
                    setSpecId("Select Specialization");
                    setMasterCourseId(e.target.value);
                  }
                }}
                id="courseSelect"
              >
                <option value="Select Course">Select Course</option>
                {course?.map((courses) => (
                  <option value={courses.course_master_id}>
                    {courses.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="mt-3">
              <Form.Label>Select Specialization</Form.Label>
              <Form.Control
                onChange={(e) => setSpecId(e.target.value)}
                value={specId}
                as="select"
                id="branchSelect"
              >
                <option value="Select Specialization">
                  Select Specialization
                </option>
                {specializationData?.map((specialize) => (
                  <option value={specialize.specilization_master_id}>
                    {specialize.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="mt-3">
              <Form.Label>Select Passout Year</Form.Label>
              <Form.Control
                onChange={(e) => setPassoutYearForm(e.target.value)}
                value={passoutYearForm}
                as="select"
                id="passoutYearSelect"
              >
                <option>Select Year</option>
                <option value={currentYear}>{currentYear}</option>
                <option value={currentYear + 1}>{currentYear + 1}</option>
                <option value={currentYear + 2}>{currentYear + 2}</option>
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="IntrestedPlacement" className="mt-3">
              <Form.Label>Intrested In College Placement</Form.Label>
              <div>
                <Form.Check
                  inline
                  type="radio"
                  label="Yes"
                  value="1"
                  name="interestedPlacement"
                  onChange={() => setInterestedPlacement(1)}
                  checked={interestedPlacement === 1}
                />
                <Form.Check
                  inline
                  type="radio"
                  label="No"
                  value="0"
                  name="interestedPlacement"
                  onChange={() => setInterestedPlacement(0)}
                  checked={interestedPlacement === 0}
                />
              </div>
            </Form.Group>

            <Form.Group controlId="intrestedHigherStudies" className="mt-3">
              <Form.Label>Intrested In Higher Studies</Form.Label>
              <div>
                <Form.Check
                  inline
                  type="radio"
                  label="Yes"
                  value="1"
                  name="interestedHigherStudy"
                  onChange={() => setInterestedHigherStudy(1)}
                  checked={interestedHigherStudy === 1}
                />
                <Form.Check
                  inline
                  type="radio"
                  label="No"
                  value="0"
                  name="interestedHigherStudy"
                  onChange={() => setInterestedHigherStudy(0)}
                  checked={interestedHigherStudy === 0}
                />
              </div>
            </Form.Group>
            {/*
            <Form.Group controlId="formPassoutYear" className="mt-3">
              <Form.Label>Passout Year</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter passout year"
                value={passoutYear}
                onChange={(e) => setPassoutYearForm(e.target.value)}
                required
              />
            </Form.Group> */}

            {/* <Button variant="primary" onClick={handleSubmit} className="mt-4">
              Add Student
            </Button> */}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setModalShow(false)} variant="danger btn-sm">
            Close
          </Button>
          <Button onClick={() => handleSubmit()} variant="primary btn-sm">
            {isEditing ? "Update" : "Add Student"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default StudentsList;
